import { Component, Input, OnChanges } from '@angular/core';
import { TranslateService } from '@services/translate/translate.service';
import { Models } from '@ibexfusion/models';
import { ImageAssetsService } from '@services/assets/image-assets.service';
import { EnvironmentService } from '@services/environment/environment.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DeeplTranslationService } from '@services/deepl-translation/deepl-translation.service';
import { MessengerService } from '@services/messenger/messenger.service';
import { EditMediaComponent } from '../../../../../dynamic-content/dynamic-content-edit/components/edit-media/edit-media.component';
import { SelectAssetsComponent } from '../../../../../../components/select-assets/select-assets.component';

@Component({
    selector: 'ibextablet-widget',
    templateUrl: './ibextablet-widget.component.html',
    styleUrls: ['./ibextablet-widget.component.scss'],
    providers: [ImageAssetsService, DeeplTranslationService],
    standalone: false
})
export class IbextabletWidgetComponent implements OnChanges {

  @Input() item: any;
  @Input() appItem: any;
  @Input() entrance: any;
  @Input() packageId: any;
  @Input() entry: any;
  @Input() availableLanguages: any;
  @Input() packageLang: any;
  codeEditorOptions = { maxLines: 20, minLines: 10, fontSize: '16px', autoScrollEditorIntoView: false };
  public imageAssetPath: any;
  imagesByPath = {};
  superadmin = false;

  constructor(
    private translate: TranslateService, private imageService: ImageAssetsService, private environmentService: EnvironmentService, private dialog: MatDialog,
    private translation: DeeplTranslationService, private ms: MessengerService
  ) {
    this.imageAssetPath = this.environmentService.getImageAssetPath();
    this.translate.get('general');
    this.ms.$superadminPrivileges.subscribe(privileges => {
      this.superadmin = !!(privileges || []).find(el => el.privilegeName === 'superadmin' && el.value === 'packages');
    });
  }

  async ngOnChanges() {
    if (!this.item?.tabletWidgetConfig?.seasonalImages?.[0]?.imagePath) {
      this.setSeasonalImages(this.item.tabletWidgetConfig)
    }
    if (!this.item?.tabletWidgetConfig?.seasonalImages) {
      this.setSeasonalImages(this.item.tabletWidgetConfig);
    }

    const paths = this.item?.tabletWidgetConfig?.seasonalImages?.map(el => el.imagePath) || [];
    const images = await this.imageService.find(0, paths.length, { path: { $in: paths } });
    images.data?.forEach(image => this.imagesByPath[image.path] = image);
  }

  setSeasonalImages(element) {
    if (!element) return;
    if (element?.seasonalImages) {
      element.seasonalImages = element.seasonalImages.filter(el => el.imagePath);
      if (element.seasonalImages.length) return;
    }
    element.seasonalImages = element.imagePath ? [this.createNewSeasonalImage(element.imagePath)] : [];
  }

  createNewSeasonalImage(imagePath) {
    const seasonalImage = new Models.PackageInstalledWidgetSeasonalImage();
    seasonalImage.populateFromJSON({ imagePath, from: new Date(new Date().getFullYear(), 0, 1), to: new Date(new Date().getFullYear(), 11, 31) });
    return seasonalImage;
  }

  async addImage() {
    const dialogRef = this.dialog.open(SelectAssetsComponent, {
      width: '880px', height: '75%', panelClass: 'select-assets-modal', data: { type: 'image', multiple: false,
        title: 'Bilder', page: 'package-image'}
    });
    const asset: Models.ImageAsset[] = await dialogRef.afterClosed().toPromise();
    if (asset?.length) {
      this.imagesByPath[asset[0].path] = asset[0];
      this.item.tabletWidgetConfig.seasonalImages.push(this.createNewSeasonalImage(asset[0].path));
    }
  }

  public async editImage(index: number) {
    let boundImageAsset;
    if (this.imagesByPath[this.item.tabletWidgetConfig.seasonalImages[index].imagePath].resizeInformation) {
      boundImageAsset = await this.imageService.get(this.imagesByPath[this.item.tabletWidgetConfig.seasonalImages[index].imagePath]._id);
    }
    const assets: Models.ImageAsset = await this.dialog.open(EditMediaComponent, {
      width: '875px', height: 'auto', panelClass: 'edit-media-modal',
      data: { asset: boundImageAsset, availableLanguages: this.availableLanguages, packageLang: this.packageLang,
        isInContent: true, page: 'navigation', dataType: 'thumbnail'}
    }).afterClosed().toPromise();
  }

  async translateText(translation, language, field) {
    translation[field] = await this.translation.translate(this.item.tabletWidgetConfig.translations.find(el => el.language === 'de')[field], language, this.packageId);
  }

  removeImage(index: number) {
    this.item.tabletWidgetConfig.seasonalImages.splice(index, 1);
  }

  getAsset(path) {
    return this.imagesByPath[path];
  }

  updateDate(field, event: any, index) {
    this.item.tabletWidgetConfig.seasonalImages[index][field] = new Date(event.value);
  }

  getTitle() {
    return (!!this.item?.tabletWidgetConfig?.translations?.find(el => el.language === 'de')?.title ? this.item?.tabletWidgetConfig?.translations?.find(el => el.language === 'de')?.title : null)
      ?? (this.appItem?.translations?.find(el => el.language === 'de')?.appTitle ?? '');
  }

  changeType(e?: any) {
    this.item?.tabletWidgetConfig?.translations?.forEach(el => { el.widgetStyle = e?.value; });
  }

  useBigPicture() {
    return this.item?.tabletWidgetConfig?.translations?.[0]?.widgetStyle === 'image';
  }

  showImageSelection() {
    const forceNoPicture = ['important-news', 'ticker', 'screensaver', 'breaking-news'];
    const noPicture = ['accommodation', 'event', 'gallery', 'information', 'news', 'offer', 'person', 'restaurant', 'social-media-feed', 'webcam'];
    return forceNoPicture.includes(this.entry?.detail?.contentType || this.entrance?.type)
      ? false : ['image', 'imageText'].includes(this.item?.translations?.[0]?.widgetStyle) ? true : !noPicture.includes(this.entry?.detail?.contentType || this.entrance?.type);

  }
}
